/* @flow */
import * as React from 'react';
import type { TFunction } from 'react-i18next';
import type { ImportSectionPreview, ImportSectionResult } from 'api/brandsBulkImport';
import { formatCount } from './formatters';
import styles from './ImportShared.module.scss';

type TypeProps = {
  section: ImportSectionPreview | ImportSectionResult,
  t: TFunction,
};

const ImportSummary = ({ section, t }: TypeProps): React.Node => {
  const hasWarningRecords = typeof section.warning_records === 'number';
  const totalRows = section.total_rows || 0;
  const createdRecords = section.created_records || 0;
  const updatedRecords = section.updated_records || 0;
  const unchangedRecords = section.unchanged_records || 0;
  const rejectedRecords = section.rejected_records || 0;
  const warningRecords = hasWarningRecords ? section.warning_records || 0 : 0;

  return (
    <div className={styles['import-summary']}>
      <div className={styles['import-summary__card']}>
        <span className={styles['import-summary__label']}>
          {t('general:reporting.brand_form.multiple.labels.total_rows')}
        </span>
        <span className={styles['import-summary__value']}>{formatCount(totalRows)}</span>
      </div>
      <div
        className={`${styles['import-summary__card']} ${styles['import-summary__card--created']}`}
      >
        <span className={styles['import-summary__label']}>
          {t('general:reporting.brand_form.multiple.labels.created_count')}
        </span>
        <span className={styles['import-summary__value']}>{formatCount(createdRecords)}</span>
      </div>
      <div
        className={`${styles['import-summary__card']} ${styles['import-summary__card--updated']}`}
      >
        <span className={styles['import-summary__label']}>
          {t('general:reporting.brand_form.multiple.labels.updated_count')}
        </span>
        <span className={styles['import-summary__value']}>{formatCount(updatedRecords)}</span>
      </div>
      <div className={styles['import-summary__card']}>
        <span className={styles['import-summary__label']}>
          {t('general:reporting.brand_form.multiple.labels.unchanged_count')}
        </span>
        <span className={styles['import-summary__value']}>{formatCount(unchangedRecords)}</span>
      </div>
      <div
        className={`${styles['import-summary__card']} ${styles['import-summary__card--rejected']}`}
      >
        <span className={styles['import-summary__label']}>
          {t('general:reporting.brand_form.multiple.labels.rejected_count')}
        </span>
        <span className={styles['import-summary__value']}>{formatCount(rejectedRecords)}</span>
      </div>
      {hasWarningRecords && (
        <div
          className={`${styles['import-summary__card']} ${
            styles['import-summary__card--warnings']
          }`}
        >
          <span className={styles['import-summary__label']}>
            {t('general:reporting.brand_form.multiple.labels.warning_records')}
          </span>
          <span className={styles['import-summary__value']}>{formatCount(warningRecords)}</span>
        </div>
      )}
    </div>
  );
};

export default ImportSummary;
